import * as React from 'react';
import withTranslate, {WithTranslateProps} from './WithTranslate';
import SimplePharmacyCalendar from './SimplePharmacyCalendar';
import {MultiCalendarSelectionType} from './MultiCalendar';

export interface MultiCalendarForComparisonProps extends WithTranslateProps {
  dummy?: number;
  startingPharmacy?: number,
  startingSecondPharmacy?: number,
}

export interface MultiCalendarForComparisonState {
  isOpen: boolean;
  selectedYear?: number;
  selectedType?: MultiCalendarSelectionType;
}

class MultiCalendarForComparison extends React.Component<MultiCalendarForComparisonProps, MultiCalendarForComparisonState> {
  state = {
    isOpen: false,
    selectedYear: new Date().getFullYear(),
    selectedType: undefined,
  } as MultiCalendarForComparisonState;

  onTypeChange = (type: MultiCalendarSelectionType) => {
    if (this.state.selectedType !== type) {
      this.setState({selectedType: type});
    }
  };

  onCalendarMove = (fly: number, sly: number) => {
    if (this.state.selectedYear !== fly) {
      this.setState({selectedYear: fly});
    }
  }

  render() {
    const startingPharmacy: number = 1; //this.props.startingPharmacy ? this.props.startingPharmacy : -1;
    const startingSecondPharmacy: number = 1; //(this.props.startingSecondPharmacy)
      //? this.props.startingSecondPharmacy
      //: (parseInt("" + startingPharmacy, 10) + 1);
    return (
      <div>
        <SimplePharmacyCalendar id={'topCal'}
                                pharmacyId={startingPharmacy}
                                hideLegend={true}
                                synchronizedScrolling={true}
                                fly={this.state.selectedYear}
                                onCalendarMove={this.onCalendarMove}
                                onTypeChange={this.onTypeChange}
                                selectedType={this.state.selectedType}
                                separateToolbox={true}
                                inMultiCalendar={true}
        />
        <SimplePharmacyCalendar id={'bottomCal'}
                                pharmacyId={startingSecondPharmacy}
                                hideLegend={true}
                                synchronizedScrolling={true}
                                fly={this.state.selectedYear}
                                onCalendarMove={this.onCalendarMove}
                                onTypeChange={this.onTypeChange}
                                selectedType={this.state.selectedType}
                                inMultiCalendar={true}
        />
        <div id={'anchor'} ref='anchor'/>
      </div>
    );
  }
}

export default withTranslate(MultiCalendarForComparison);
